"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsSavedOffer2Baskets = void 0;
var _ramda = require("ramda");
var _selectors = require("../../../../../../store/selectors");
var getIsSavedOffer2Baskets = exports.getIsSavedOffer2Baskets = (0, _ramda.converge)(function (offersAsMap, offerID) {
  var _offersAsMap$offerID;
  return (_offersAsMap$offerID = offersAsMap[offerID]) !== null && _offersAsMap$offerID !== void 0 ? _offersAsMap$offerID : false;
}, [(0, _ramda.pipe)(_selectors.domain, (0, _ramda.prop)('savedOffers2Baskets')), function (_, _ref) {
  var offerID = _ref.offerID;
  return offerID;
}]);